// extracted by mini-css-extract-plugin
export default {"card":"default-card_card__ivZuE","cardHeader":"default-card_cardHeader__Hej5F","cardTitle":"default-card_cardTitle__mvB1f","cardContent":"default-card_cardContent__ezqUJ"};